import { BLANK_DATE_STRING, DEFAULT_ID } from "@usas/ui-web/utils/Constants";
import { isValidDate } from "@usas/ui-web/utils/validation";

export const localValidate = (formState) => {
  let errors = {};
  const effectiveDate = new Date(formState.effectiveDate);
  const expirationDate = new Date(formState.expirationDate);

  if (!(formState.orgUnit?.length > 0)) {
    errors.orgUnit = 'Organization is required';
  }

  if (!(formState.orgRoleId) || formState.orgRoleId === DEFAULT_ID) {
    errors.orgRoleId = 'Security Role is required';
  }

  if (formState.effectiveDate === BLANK_DATE_STRING
    || !isValidDate(formState.effectiveDate)) {
    errors.effectiveDate = 'Effective Date must be a valid date';
  }

  if (formState.hasNoExpirationDate === false) {
    if (formState.expirationDate === BLANK_DATE_STRING
      || !isValidDate(formState.expirationDate)) {
      errors.expirationDate = 'Expiration Date must be a valid date';
    }

    if (expirationDate < effectiveDate) {
      errors.effectiveDate = 'Effective Date must be before the Expiration Date';
      errors.expirationDate = 'Expiration Date must be after the Effective Date';
    }

    if (formState.effectiveDate !== BLANK_DATE_STRING
      && formState.expirationDate === BLANK_DATE_STRING) {
      errors.expirationDate = 'Expiration Date is required if there is a Effective Date';
    }

    if (formState.effectiveDate === BLANK_DATE_STRING
      && formState.expirationDate !== BLANK_DATE_STRING) {
      errors.effectiveDate = 'Effective Date is required if there is a Expiration Date';
    }
  }

  return errors;
};

const UserGroupAddFormValidation = async (formState) => {
  let errors = localValidate(formState);

  return errors ? errors : {};
};

export default UserGroupAddFormValidation;